const PREFIX = 'POST_POPULAR'

export const POST_POPULAR_BY_CATEGORY_FETCH_LOADING = `${PREFIX}_BY_CATEGORY_FETCH_STATUS`
export const POST_POPULAR_BY_CATEGORY_FETCH = `${PREFIX}_BY_CATEGORY_FETCH`
export const POST_POPULAR_BY_CATEGORY_FETCH_ERROR = `${PREFIX}_BY_CATEGORY_FETCH_ERROR`

export const POST_POPULAR_FETCH = `${PREFIX}_FETCH`
export const POST_POPULAR_FETCH_LOADING = `${PREFIX}_FETCH_LOADING`
export const POST_POPULAR_FETCH_ERROR = `${PREFIX}_FETCH_ERROR`

export const POST_POPULAR_PREVIEW_GET = `${PREFIX}_PREVIEW_GET`
export const POST_POPULAR_PREVIEW_GET_LOADING = `${PREFIX}_PREVIEW_GET_LOADING`
export const POST_POPULAR_PREVIEW_GET_ERROR = `${PREFIX}_PREVIEW_GET_ERROR`

export const POST_POPULAR_LOADING = `${PREFIX}_LOADING`
